import * as config from "./../configuration/index";
import QueryAttribute from "./QueryAttribute";
import QueryBuilder from "./QueryBuilder";
const QueryComposer = (paramList: QueryBuilder[]) => {
  let list = paramList;
  let result: QueryBuilder[] = [];
  const solvedQueryIds: Record<string, boolean> = {};
  // default attributes for each of the queries
  list.forEach((q) => {
    q.attributes(["typename", {}]);
    q.attributes([
      "related",
      { relation: "parentObjects", as: "parent_element_id" },
    ]);
  });
  /**
   *  Try to resolve the queries using the cached data
   */
  list.forEach((q) => {
    const resolvedValues = q.resolveQueryUsingCache();
    if (resolvedValues !== null) {
      // infoCacheLogGreen(
      //  "Succesfully resolved cached query ",
      //  q.toMeaQuery(q.elementIds)
      // );
      if (config.System.query.logQueries) q.prettyLogQuery("green");
      if (config.System.query.logQueries)
        console.log("Solved query ", q, "cached values", resolvedValues);
      q.resolve(resolvedValues);
      solvedQueryIds[q.queryId] = true;
    } else {
      if (config.System.query.logQueries) q.prettyLogQuery("red");
    }
  });
  // remove resolved queries from the list
  list = list.filter((q) => !solvedQueryIds[q.queryId]);
  /**
   *  Create a list of single element queries
   */
  let ids: string[] = [];
  let singleElementQueries = list.filter((q) => {
    if (
      q.signature() === "[]"
      // &&
      // q.getAttributes().filter(a => a.getName() === 'id').length === 0
    ) {
      ids = ids.concat(q.elementIds);
      return true;
    }
    result.push(q);
    return false;
  });
  /**
   * Optimization for single element queries:
   *
   * 1. Create a new query which replaces all queries for single elements like [SC.11.22] with one query
   * 2. Collect all attributes from other single element queries to that single query
   * 3. Mark aliased attributes so that when query returns we can return correct attributes to correct query
   */
  if (singleElementQueries.length > 0) {
    const singleElementQuery = new QueryBuilder(ids);
    // this query will replace other single element queries
    singleElementQuery.replacesQueries = singleElementQueries;
    // merge attributes of the single element queries
    if (config.System.query.logQueries)
      console.log("singleElementQueries", singleElementQueries);
    const attributes: Record<string, QueryAttribute> = {};
    singleElementQueries.forEach((q) => {
      /**
       * Here we remove all duplicate attributes from the query and mark the aliased IDs to the original query
       */
      q.getAttributes().forEach((attr) => {
        if (attributes[attr.signature()]) {
          // attribute with same signature was already added, mark it as alias in the queryAliasId
          // so that we can then detect which attribute in the resulting query corresponds to the
          // attribute the original query was asking
          const otherAttr = attributes[attr.signature()];
          attr.queryAliasId = otherAttr.id;
        } else {
          attributes[attr.signature()] = attr;
        }
      });
    });
    const singleElementAttributes = Object.entries(attributes).map(
      ([name, value]) => {
        return value;
      }
    );
    singleElementQuery.setAttributes(singleElementAttributes);
    if (config.System.query.logQueries)
      console.log(
        "single query attributes ",
        singleElementQuery.toMeaAttributes()
      );
    result.push(singleElementQuery);
  }
  /**
   * Finally filter all the solved queries, could be redundant but if the code changes just to be sure
   */
  return result.filter((q) => {
    return !solvedQueryIds[q.queryId];
  });
};
export default QueryComposer;
/*
Implementation notes:

parentid is obtained using
  related(relation=parentObjects,as="parentid")

measurehierachy is also asking
  typename(as="temporary_typename")
  scorecardid(as="temporary_scorecardid"), topelement(as="temporary_topelementid")


In theory you could also optimize queries for direct children with a type selector so that if you ask the ID and
the children then you can detect the correct target for the query from the parentid

@obj = [SC.1371340151.1469824075];
@obj += [SC.1371340151.1469824075].childobjects;
@obj

- [SC.1371340151.1469824075].childobjects this path has parentid = "SC.1371340151.1469824075"
- [SC.1371340151.1469824075] this path has id = "SC.1371340151.1469824075"

If recursive is used, there may be some "gaps" which can not be filled if filters are used.

For example, for a sector, you could ask [SC.1371340151.283246050].childobjects(recursive=6)
and then get the elements from that query

[SC.1371340151.283246050].childobjects(recursive=6, criteria="typename=\"Sub-Sector\"")
duration: 109ms

[SC.1371340151.283246050].childobjects(recursive=6)
duration: 115ms


*/
